'use client'

import { useState } from "react"
import useQueryStore from '@/store/queryStore'
import { toast } from '@/hooks/use-toast'

export default function NewsletterForm({ translations }: any) {
  const { createQuery } = useQueryStore()

  const [email, setEmail] = useState("")
  const [error, setError] = useState("")

  const validateEmail = (value: string) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!email) {
      setError("Email is required")
      return
    }

    if (!validateEmail(email)) {
      setError("Please enter a valid email address")
      return
    }

    setError("")

    const result = await createQuery({ email })

    if (result?.status) {
      toast({ title: "Success", description: result?.message })
      setEmail("")
    } else {
      toast({
        title: "Error",
        description: result?.error || result?.message,
        variant: "destructive"
      })
    }
  }

  return (
    <form onSubmit={handleSubmit} noValidate className="mb-8">
      <div className="flex border border-gray-300 rounded-md p-1">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={translations["entr_email"] || "Enter your email"}
          className="rounded-l px-4 w-full focus:outline-none"
        />
        <button
          type="submit"
          className="bg-[#8B5C2A] text-white px-4 py-1 rounded-md hover:bg-[#a06a32]"
        >
          {translations["submit"] || "Submit"}
        </button>
      </div>

      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </form>
  )
}
